import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useWorld } from '../../contexts/WorldDataContext';
import { EntityThumb } from '../world/EntityThumb';
import { resolveItemSources } from '../../utils/itemSources';
import { itemName, itemPath, mapName } from '../../utils/worldFormat';

/** Ítems de mascotas con vías documentadas aparte de su receta (las recetas siguen marcadas como clásicas). */
const PET_ITEMS = ['13,31@0', '13,31@1', '13,53'];

/**
 * Otras formas de obtención documentadas en los archivos (rutas de 10–14), con sus condiciones.
 * Una receta pendiente no oculta estas vías.
 */
export function PetObtainRoutes() {
  const world = useWorld();
  const w = world.status === 'ready' ? world.data : undefined;
  const rows = useMemo(() => {
    if (!w) return [];
    const fenrir = Array.from(w.items.values()).filter(it => /^horn of fenrir$/i.test(it.name)).map(it => it.id);
    return [...PET_ITEMS, ...fenrir].filter(id => w.items.has(id) || w.variants.has(id)).map(id => {
      const sources = resolveItemSources(w, id).filter(s => !s.blocked);
      const ways = sources.map(s => {
        const maps = Array.from(new Set([...s.targets.map(t => t.mapId), ...s.eventMaps.map(e => e.mapId), s.eventMapId].filter((m): m is number => m !== undefined))).map(m => mapName(w, m));
        return {
          key: s.key,
          label: s.label ?? s.title,
          detail: [maps.length ? maps.slice(0, 3).join(', ') + (maps.length > 3 ? ` y ${maps.length - 3} más` : '') : '', s.conditions ?? '', s.status === 'disabled' ? 'Desactivada en la configuración' : ''].filter(Boolean).join(' · ')
        };
      });
      return {
        id,
        name: itemName(w, id),
        ways
      };
    }).filter(r => r.ways.length);
  }, [w]);
  if (!rows.length) return null;
  return <section aria-labelledby="h-pet-routes" className="scroll-mt-24" data-id="element-978" data-mp="1kfa182fldnua">
      <h2 id="h-pet-routes" className="font-cinzel text-lg font-bold text-white md:text-xl" data-id="element-979" data-mp="1pc0gwonhihf6">Otras formas de obtención documentadas</h2>
      <p className="mt-1 text-sm text-gray-400" data-id="element-980" data-mp="2snzg3svex0a2">Vías que figuran en la configuración del 08/10/2026, aparte de las recetas. No comprobadas dentro del juego.</p>
      <ul className="mt-3 divide-y divide-white/5 rounded-2xl border border-white/10" data-id="element-981" data-mp="31ontqmgw8ymf">
        {rows.map(r => <li key={r.id} className="flex flex-col gap-2 p-3.5 md:flex-row md:items-start md:gap-4 md:p-4" data-id="element-982" data-mp="2wojbaqwfdttk">
            <span className="flex min-w-0 items-center gap-3 md:w-64 md:shrink-0" data-id="element-983" data-mp="3bl0m9h0pd6fl">
              <EntityThumb entity={{
            type: 'item',
            id: r.id
          }} name={r.name} placeholder data-id="element-984" data-mp="36mfmtjt9yqs7" />
              <Link to={itemPath(r.id)} className="min-w-0 truncate font-semibold text-white underline decoration-white/20 underline-offset-4 hover:text-[#D4AF37]" data-id="element-985" data-mp="3kf58to8szvpb">
                {r.name}
              </Link>
            </span>
            <ul className="min-w-0 flex-1 space-y-1 text-sm" data-id="element-986" data-mp="3udkx7jgg4qv4">
              {r.ways.slice(0, 4).map(wy => <li key={wy.key} className="text-gray-300" data-id="element-987" data-mp="3pbvmy611sh83">
                  <span className="font-semibold text-white" data-id="element-988" data-mp="cvff649v5jp7">{wy.label}</span>
                  {wy.detail && <span className="text-gray-400" data-id="element-989" data-mp="htqq6ibwa090"> · {wy.detail}</span>}
                </li>)}
              {r.ways.length > 4 && <li data-id="element-990" data-mp="2yaphugt763n">
                  <Link to={itemPath(r.id)} className="text-xs font-semibold text-[#D4AF37] underline-offset-4 hover:underline" data-id="element-991" data-mp="7vb08iolsx13">
                    Ver las {r.ways.length} vías en su ficha
                  </Link>
                </li>}
            </ul>
          </li>)}
      </ul>
    </section>;
}